import React, { useContext, useEffect, useState } from "react";
import {
  Autocomplete,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { useQuery } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { GET_PARTY_FOR_SELECT } from "../../Schema/SelectSchema";
import PartyForm from "../Party/PartyForm";
export const MultilineSelectParties = ({
  className,
  onChange,
  value = [], // default multiple empty array
  buttonAdd = true,
  helperText,
  error,
}) => {
  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_PARTY_FOR_SELECT, {
    onCompleted: ({ getPartyForSelect }) => {
      const data = getPartyForSelect?.map((e) => ({
        id: e?._id,
        title: e?.partyName,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      {buttonAdd && (
        <Stack
          direction="row"
          alignItems="flex-end"
          justifyContent="space-between"
        >
          <Typography className={t("class-name-field-title")}>
            {t("thead_party_in_mandate")}
          </Typography>
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>

          {open && (
            <PartyForm
              open={open}
              hideBackdrop={true}
              setRefetch={refetch}
              dialogTitle={"Create"}
              handleClose={handleClose}
            />
          )}
        </Stack>
      )}

      <Autocomplete
        multiple
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)} // val = array of selected objects
        getOptionLabel={(option) => option?.title || ""}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};
